import {
  Component, OnInit, ExistingProvider, forwardRef, HostListener,
} from '@angular/core';
import {
  UntypedFormGroup, UntypedFormBuilder, Validators, NG_VALUE_ACCESSOR, ControlValueAccessor,
} from '@angular/forms';
import { IActivityVariations } from 'typings/section-types';
import { noop } from 'lodash';

export const SECTION_ACTIVITY_VARIATIONS_CONTROL_VALUE_ACCESSOR: ExistingProvider = {
  provide: NG_VALUE_ACCESSOR,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  useExisting: forwardRef(() => ActivityVariationsSectionComponent),
  multi: true,
};


@Component({
    selector: 'app-activity-variations-section',
    templateUrl: './activity-variations-section.component.html',
    styleUrls: ['./activity-variations-section.component.scss'],
    providers: [SECTION_ACTIVITY_VARIATIONS_CONTROL_VALUE_ACCESSOR],
    standalone: false
})
export class ActivityVariationsSectionComponent implements OnInit, ControlValueAccessor {
  public form: UntypedFormGroup;

  /** Value we will call whenever our form is touched */
  private onTouchedCallback: Function = noop;

  /** Function we will call whenever the value changes */
  private onChangeCallback: (val: IActivityVariations) => void = noop;

  @HostListener('blur') onBlur() {
    this.onTouchedCallback();
  }

  constructor(
    public fb: UntypedFormBuilder,
  ) {
    this.form = this.fb.group({
      title: ['', Validators.required],
      subtitle: [],
      content: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.form.valueChanges.subscribe((formValue) => {
      this.onChangeCallback(formValue);
    });
  }

  writeValue(value: IActivityVariations) {
    if (value) {
      this.form.get('title').setValue(value.title || '');
      this.form.get('subtitle').setValue(value.subtitle || '');
      this.form.get('content').setValue(value.content || '');
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }
}
